import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/auth.module'
import events from '@/store/events.module'
import members from '@/store/members.module'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export const store =  new Vuex.Store({
    modules: {
        auth,
        events,
        members
    },
    strict: debug
})